module.exports = __webpack_public_path__ + "img/drink_fanta.51870f1c.png";